import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { GetInvestigationStatusSnapshotsQuery } from './get-status-snapshots.query';
import { GetInvestigationStatusSnapshotsResult } from './get-status-snapshots.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationStatusSnapshotsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationStatusSnapshotsQuery): Observable<GetInvestigationStatusSnapshotsResult> {
    this._state.setLoadingStatusSnapshots(true);
    this._state.setErrorStatusSnapshots(null);

    return this._repository.getStatusSnapshots(query.investigationId).pipe(
      tap((statusSnapshots) => {
        this._state.setStatusSnapshots(statusSnapshots);
        this._state.setLoadingStatusSnapshots(false);
      }),
      map((statusSnapshots) => ({ statusSnapshots })),
      catchError((error) => {
        this._state.setErrorStatusSnapshots(error.message || 'Failed to get status snapshots');
        this._state.setLoadingStatusSnapshots(false);
        return throwError(() => error);
      }),
    );
  }
}
